<template>
  <v-form ref="form">
    <v-select
      id="consultant-select"
      v-model="filter.usuarioId"
      item-text="nome"
      item-name="usuarioId"
      item-value="usuarioId"
      :items="users"
      :label="title"
      :placeholder="title"
      clearable
      :rules="rules"
      :outlined="outlined"
      :return-object="true"
      hide-details="auto"
    >
      <template #item="{ item }">
        <span
          >{{ item.nome }}
          <span class="eixoNaOb" v-if="!item.habilitado"
            >- usuário desabilitado</span
          >
        </span>
      </template>
      <template slot="no-data"> Nenhum usuário retornado </template>
    </v-select>
  </v-form>
</template>

<script>
import { userAPI } from "./UserAPI";

export default {
  name: "AppConsultantCombobox",
  props: ["filter", "label", "rules", "outlined", "returnObject"],
  mounted() {
    this.load();
  },
  methods: {
    load() {
      userAPI
        .list()
        .then((resp) => {
          this.users = resp.data.map((item) => ({
            ...item,
            disabled: !item.habilitado,
          }));
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter usuários");
        });
    },
    async check() {
      if (!this.$refs.form) return true;
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
  data() {
    return {
      users: [],
      title: this.label || "Responsável",
    };
  },
};
</script>
